import { render } from "./SimpleFooter.vue?vue&type=template&id=59ceb658&scoped=true"
import script from "./SimpleFooter.vue?vue&type=script&lang=js"
export * from "./SimpleFooter.vue?vue&type=script&lang=js"

import "./SimpleFooter.vue?vue&type=style&index=0&id=59ceb658&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.44_vue@3.5.44_webpack@5.112.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ceb658"]])

export default __exports__